import { QueryObserverOptions, useQuery } from 'react-query';
import { getNewUploadVersion } from '../api';

type UseQueryOptionsKeys = Pick<QueryObserverOptions<number>, 'enabled'>;

export default function useGetNewUploadVersion(
  inspectionSummaryFileName: string,
  options?: UseQueryOptionsKeys
) {
  const { data, isFetching } = useQuery(
    ['uploadVersionByInspectionSummaryFileName', inspectionSummaryFileName],
    () => getNewUploadVersion(inspectionSummaryFileName),
    {
      ...options,
    }
  );

  return { uploadVersion: data, isFetching };
}
